import { Injectable } from '@angular/core';
import { IMoreInfo } from '../interfaces/more-info.interface';
import { EnumTypeDocumentUploaded } from '../enums/WSS2/type.enum';
import { EnumCardSelected } from '../enums/card-selected.enum';

@Injectable({
  providedIn: 'root'
})
export class MoreInfoService {
  public moreInfoData: IMoreInfo = {
    retakeCustomerDecision: false,
    pseRetake: false,
    pseOff: false,
    retention: '4',
    landing2022: false,
    retakeReturnedByPse: false,
    retake: false,
    isUploadedAnyDoc: false,
    rpp2DocsCharge: EnumTypeDocumentUploaded.DOCUMENT_NOT_UPLOADED,
    failedDocumentsToCharge: false,
    isPSEAsisstedSaleEnabled: false,
    cdtNumber: '1',
    getParams: false,
    originalTransactionId: '',
    scoreRecaptcha: '0.2',
    isAssistedSale: false,
    otpErrorGenerate: false,
    generateOTPCode: 0,
    cardSelected: EnumCardSelected.NO_CARD_SELECTED,
    isShowedBackRedirection: false,
    hasConsent: false
  };

  getMoreInfo(): IMoreInfo {
    return this.moreInfoData;
  }

  setMoreInfo(data: IMoreInfo) {
    this.moreInfoData = data;
  }
}
